import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
// Sentry: inicializar antes do render (VITE_SENTRY_DSN deve estar no .env.local da Vercel)
import './sentry.config.js'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
